// Display variant of the page, derived ONLY from the generic properties of the convention parameters
// (answerLength, marker, keyword, alphabet). The page knows no family name and computes no answer.
export const VARIANTS = Object.freeze({
    NOTHING_TO_TYPE: 'NOTHING_TO_TYPE',
    SECRET: 'SECRET',
    COPY: 'COPY',
    UNKNOWN: 'UNKNOWN',
});

const isNonEmptyString = (value) => typeof value === 'string' && value.length > 0;

const isParameters = (parameters) =>
    parameters !== null
    && typeof parameters === 'object'
    && !Array.isArray(parameters)
    && Number.isInteger(parameters.answerLength)
    && parameters.answerLength >= 0;

export const getDisplayVariant = (parameters) => {
    if (!isParameters(parameters)) return VARIANTS.UNKNOWN;
    if (parameters.answerLength === 0) return VARIANTS.NOTHING_TO_TYPE;
    if (isNonEmptyString(parameters.marker) || isNonEmptyString(parameters.keyword)) return VARIANTS.SECRET;
    return VARIANTS.COPY;
};

// Practice (examples + exercise) is only loaded for the variants that have something to type.
export const hasPractice = (variant) => variant === VARIANTS.SECRET || variant === VARIANTS.COPY;

export const answerInputProps = (parameters) => {
    const props = { inputMode: parameters && parameters.alphabet === 'DIGITS' ? 'numeric' : 'text' };
    if (parameters && Number.isInteger(parameters.answerLength) && parameters.answerLength > 0) {
        props.maxLength = parameters.answerLength;
    }
    return props;
};
